export const isJobPage = (pathname) => {
    return /\/job\/[a-z0-9]+$/i.test(pathname);
  };
  
  export const extractJobIdFromPathname = (pathname) => {
    const match = pathname.match(/\/job\/([a-z0-9]+)$/i);
    return match ? match[1] : null;
  };
  